export default "/images/1e29a9590c5c5a1c53ec19b5e5b0e70c.avif";